export enum ToastType {
  Success = 'success',
  Error = 'error',
}

export type ToastActionType = 'success' | 'error';

export interface ToastConfig {
  type: ToastActionType;
  message: string;
  show?: boolean;
  duration?: number;
}

export interface ConnectionLogo {
  id?: number;
  url: string;
  filename: string;
}
